<template>
    <div>
        <label class="switch" v-if="!loading">
            <input type="hidden" :name="name" :value="inputValue ? onValue : offValue">
            <input type="checkbox" @click.stop="sliderToggle" v-model="inputValue">
            <span class="strip">
                <span class="on">{{ onText }}</span>
                <span class="pin"></span>
                <span class="off">{{ offText }}</span>
            </span>
        </label>

        <div v-if="loading">
            <i class="text-orange d-inline-block fi-arrows-cw spin" style="margin-right: 24px;"></i>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
    props: {
        name: {type: String, required: true},
        onText: {type: String, default: 'Yes'},
        offText: {type: String, default: 'No'},
        onValue: {type: String, default: 'Y'},
        offValue: {type: String, default: 'N'},
        loading: {type: Boolean, default: false},
        modelValue: {type: Boolean, default: false},
    },
    computed: {
        labelText(): string {
            if (this.modelValue) {
                return this.onText;
            }

            return this.offText;
        },
    },
    data() {
        return {
            inputValue: false,
        };
    },
    emits: [
        'update:modelValue',
        'change',
    ],
    mounted() {
        this.inputValue = this.modelValue;
    },
    watch: {
        modelValue(newValue) {
            if (this.inputValue !== newValue) {
                this.inputValue = newValue;
            }
        },
    },
    methods: {
        sliderToggle() {
            this.inputValue = !this.inputValue;
            this.$emit('update:modelValue', this.inputValue);
            this.$emit('change', this.inputValue);
        },
    },
});
</script>
